// TODO: change this when the roles are approved

export const AUTHROLE = {
	NOTALLOWED: 'empty'
};

export enum AUTHPATH {
	UNAUTHORIZED = 'unauthorized'
}

export enum AUTHMESSAGE {
	UNAUTHORIZED = 'You do not have access to this application. You may have the incorrect URL. Please reach out to an administrator',
	SESSIONEXPIRE = 'Your session has expired or need to be checked',
	LOGIN = 'You are not logged into our system',
	LOGOUT = 'You logged out, please login again',
	PERMISSION_ROLES_REQUIRED = `<span>Your account <strong>does not have sufficient privileges</strong> to access this application.</span> </br><span>Please reach out to an administrator.</span>`,
	TOKEN_EXPIRED = `Token Expired, please, visit the link provided.`,
}

export enum AUTHACTIONS {
	LOGIN = 'LOGIN',
	LOGOUT = 'LOGOUT',
	UNAUTHORIZED = 'UNAUTHORIZED',
	SESSIONEXPIRE = 'SESSIONEXPIRE',
	PERMISSION_ROLES_REQUIRED = 'PERMISSIONS_ROLES_REQUIRED',
	TOKEN_EXPIRED = `TOKEN_EXPIRED`
}

export const AUTHREDIRECTIONACTION = [
	{
		TYPE: AUTHACTIONS.SESSIONEXPIRE,
		MSG: AUTHMESSAGE.SESSIONEXPIRE,
		FORCE: false
	},
	{
		TYPE: AUTHACTIONS.UNAUTHORIZED,
		MSG: AUTHMESSAGE.UNAUTHORIZED,
		FORCE: true
	},
	{
		TYPE: AUTHACTIONS.LOGIN,
		MSG: AUTHMESSAGE.LOGIN,
		FORCE: false
	},
	{
		TYPE: AUTHACTIONS.PERMISSION_ROLES_REQUIRED,
		MSG: AUTHMESSAGE.PERMISSION_ROLES_REQUIRED,
		FORCE: true
	},
	{
		TYPE: AUTHACTIONS.LOGOUT,
		MSG: AUTHMESSAGE.LOGOUT,
		FORCE: true
	}
];
